import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  ArchiveCigarProductionPlanTask,
  CreateCigarProductionScheduleTask,
  CreateEmployeeTask,
  CreateTobaccoProductionPlanningTask,
  CreateCycleCountForCigarProductionPlanTask,
  DeleteCigarProductionPlanTask,
  GetEmployeeTasks,
  GetTechnicalRawEmployeeTasks,
  GetEmployeeTaskHistory,
  UpdateEmployeeTask,
  UpdateCigarProductionPlanTaskStatus,
} from './thunks';
import {
  ArchiveCigarProductionPlanTaskReducer,
  CreateCigarProductionScheduleTaskReducer,
  CreateEmployeeTaskReducer,
  CreateTobaccoProductionPlanningTaskReducer,
  CreateCycleCountForCigarProductionPlanTaskReducer,
  DeleteCigarProductionPlanTaskReducer,
  GetEmployeeTasksReducer,
  GetTechnicalRawEmployeeTasksReducer,
  GetEmployeeTaskHistoryReducer,
  ResetEmployeeTasksStateReducer,
  ClearEmployeeTaskHistoryReducer,
  UpdateEmployeeTaskReducer,
  UpdateCigarProductionPlanTaskStatusReducer,
} from './reducers';

// ----------------------------------------------------------------------------

export const slice = createSlice({
  name: 'employeeTasks',
  initialState,
  reducers: {
    ResetEmployeeTasksState: ResetEmployeeTasksStateReducer,
    ClearEmployeeTaskHistory: ClearEmployeeTaskHistoryReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetEmployeeTasks, GetEmployeeTasksReducer);
    addExtraReducer(builder, GetTechnicalRawEmployeeTasks, GetTechnicalRawEmployeeTasksReducer);
    addExtraReducer(
      builder,
      CreateCycleCountForCigarProductionPlanTask,
      CreateCycleCountForCigarProductionPlanTaskReducer
    );
    addExtraReducer(builder, CreateCigarProductionScheduleTask, CreateCigarProductionScheduleTaskReducer);
    addExtraReducer(builder, CreateTobaccoProductionPlanningTask, CreateTobaccoProductionPlanningTaskReducer);
    addExtraReducer(builder, CreateEmployeeTask, CreateEmployeeTaskReducer);
    addExtraReducer(builder, ArchiveCigarProductionPlanTask, ArchiveCigarProductionPlanTaskReducer);
    addExtraReducer(builder, DeleteCigarProductionPlanTask, DeleteCigarProductionPlanTaskReducer);
    addExtraReducer(builder, UpdateCigarProductionPlanTaskStatus, UpdateCigarProductionPlanTaskStatusReducer);
    addExtraReducer(builder, UpdateEmployeeTask, UpdateEmployeeTaskReducer);
    addExtraReducer(builder, GetEmployeeTaskHistory, GetEmployeeTaskHistoryReducer);
  },
});

export default slice.reducer;
